import { createFileRoute } from "@tanstack/react-router";

import { ClientGoalsView } from "~/components/engagement/planning/client-goals-view";
import { useUserInfoForEngagement } from "~/lib/queries/engagementQuery";

export const Route = createFileRoute(
  "/_user/my-coaching/clients/programs/$engagementId/client-goals",
)({
  staticData: { title: "Client's goals" },
  component: ClientGoalsPage,
});

function ClientGoalsPage() {
  const { engagementId } = Route.useParams();
  const { data: userInfo } = useUserInfoForEngagement(engagementId);

  return <ClientGoalsView clientId={userInfo?.userId} />;
}
